import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'form-input-password',
  template: `
    <div class="form-group">
      <label class="col-form-label font-weight-bold">{{label}}</label>
      <input type="password" class="form-control" 
             [class.is-invalid]="control.invalid && control.dirty"
             [placeholder]="placeholder" 
             [formControl]="control"
             [minlength]="minLength"
             [autocomplete]="autocomplete">
      <div *ngIf="control.invalid && control.dirty" class="text-danger-form">{{errorMsg ? errorMsg : 'campoObbligatorio' | translate}}</div>
    </div>
  `,
})
export class FormInputPasswordComponent {

  @Input() control: AbstractControl;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() errorMsg: string;
  @Input() minLength = 5;
  @Input() autocomplete = "off";

}
